import { UnreachableCaseError } from 'main/util/ts'
import {
  EXTERNAL_NORMAL as NORMAL,
  EXTERNAL_SELECTED as SELECTED,
  ExternalPinSource,
  ListingType,
  Pin,
  PinType,
} from '../types'

export function markerHeightForPin(pin: Pin) {
  switch (pin._type) {
    case PinType.Generic:
    case PinType.Wonderschool:
      return 70
    default:
      throw new UnreachableCaseError(pin)
  }
}

export function markerWidthForPin(pin: Pin) {
  switch (pin._type) {
    case PinType.Generic:
    case PinType.Wonderschool:
      return 65
    default:
      throw new UnreachableCaseError(pin)
  }
}

export function markerPositionOffsetForPin(pin: Pin) {
  switch (pin._type) {
    case PinType.Generic:
    case PinType.Wonderschool:
      return -62
    default:
      throw new UnreachableCaseError(pin)
  }
}

export function pinSource(
  type: ListingType,
  selected: boolean,
  uuid: string,
  src?: ExternalPinSource,
): string | undefined {
  // NOTE (cam): pulls a marker asset for white-label
  // Markers are either SELECTED or NORMAL and belong to on- or off-platform schools (INTERNAL, EXTERNAL)
  return src ? src[selected ? SELECTED : NORMAL][type] : `https://ucarecdn.com/${uuid}/`
}
